// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-pointer[data-v-06d1bc7a]{cursor:pointer}`, "",{"version":3,"sources":["webpack://./ClientApp/components/pivot/templates/selectTemplateModal/selectTemplateModal.vue.html"],"names":[],"mappings":"AACA,4BACI,cAAA","sourcesContent":["\n.c-pointer {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
